import { AbstractControl, ValidationErrors } from '@angular/forms';

import { isValidPhoneNumber } from 'libphonenumber-js';

const PHONE_NUMBER_REGION = 'ID';

export function phoneNumberValidator(
  control: AbstractControl,
): ValidationErrors | null {
  // Validator should allow undefined, null, and empty strings, as they are validated by required props
  if (
    control.value === undefined ||
    control.value === null ||
    control.value === '' ||
    (typeof control.value === 'string' &&
      isValidPhoneNumber(control.value, PHONE_NUMBER_REGION))
  ) {
    return null;
  }

  return {
    invalidPhoneNumber: { value: control.value },
  };
}
